import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ListTodo, Check, Circle, ChevronRight } from 'lucide-react';
import { getDashboardTasks } from '../utils/api';
import { DEMO_STEPS } from '../data/demoCampaignSteps';

const demoTask = () => {
  const completed = parseInt(localStorage.getItem('demo_campaign_completed_steps') || '0', 10) || 0;
  if (completed >= DEMO_STEPS.length) {
    return {
      id: 'demo_campaign',
      title: 'Demo Campaign complete',
      subtitle: 'All steps finished — nice work',
      status: 'done',
      link: '/demo-campaign',
    };
  }
  const next = DEMO_STEPS[completed];
  return {
    id: 'demo_campaign',
    title: `Step ${next.id}: ${next.title} — Demo Campaign`,
    subtitle: next.shortDesc,
    status: 'pending',
    link: '/demo-campaign',
  };
};

export const DashboardTasks = () => {
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    getDashboardTasks()
      .then((res) => {
        const merged = [demoTask(), ...res.data.tasks];
        merged.sort((a, b) => (a.status === 'pending' ? 0 : 1) - (b.status === 'pending' ? 0 : 1));
        setTasks(merged);
      })
      .catch(() => setTasks([demoTask()]));
  }, []);

  if (!tasks) return null;
  const pendingCount = tasks.filter((t) => t.status === 'pending').length;

  return (
    <div className="card" data-testid="dashboard-tasks-panel">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <ListTodo size={18} className="text-lime" /> Your Tasks
        </h2>
        <span
          data-testid="tasks-pending-count"
          className={`px-2.5 py-1 rounded-full text-xs font-bold ${
            pendingCount > 0 ? 'bg-orange/15 text-orange border border-orange/40' : 'bg-lime/15 text-lime border border-lime/40'
          }`}
        >
          {pendingCount > 0 ? `${pendingCount} pending` : 'All done'}
        </span>
      </div>
      <p className="text-xs text-gray mb-4">What your marketing needs from you right now — across everything.</p>
      <div className="space-y-2">
        {tasks.slice(0, 6).map((t) => (
          <Link
            key={t.id}
            to={t.link}
            data-testid={`task-item-${t.id}`}
            className={`flex items-center gap-3 p-3 rounded-lg border transition-colors group ${
              t.status === 'pending'
                ? 'border-divider bg-black hover:border-orange/60'
                : 'border-divider/50 bg-black/40 opacity-60 hover:opacity-90'
            }`}
          >
            {t.status === 'done' ? (
              <span className="w-6 h-6 rounded-full bg-lime flex items-center justify-center shrink-0">
                <Check size={13} className="text-black" />
              </span>
            ) : (
              <Circle size={22} className="text-orange shrink-0" />
            )}
            <span className="flex-1 min-w-0">
              <span className={`block text-sm font-semibold truncate ${t.status === 'done' ? 'text-gray-light line-through' : 'text-white'}`}>
                {t.title}
              </span>
              <span className="block text-xs text-gray truncate">{t.subtitle}</span>
            </span>
            <ChevronRight size={15} className="text-gray group-hover:text-white shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
};
